import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import type { EmailCampaignProspect } from '@/types/emailCampaigns'

export function useCampaignProspects(campaignId: string | undefined) {
  return useQuery({
    queryKey: ['email_campaign_prospects', campaignId],
    enabled: !!campaignId,
    queryFn: async (): Promise<EmailCampaignProspect[]> => {
      if (!campaignId) return []
      const { data, error } = await (supabase as any)
        .from('email_campaign_prospects')
        .select('*')
        .eq('campaign_id', campaignId)
        .order('created_at')
      if (error) throw error
      return (data ?? []) as EmailCampaignProspect[]
    },
    refetchInterval: 15_000,
  })
}

export function useExcludeFromCampaign() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await (supabase as any)
        .from('email_campaign_prospects')
        .update({ status: 'excluded' })
        .eq('id', id)
        .eq('status', 'queued')
      if (error) throw error
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['email_campaign_prospects'] })
      qc.invalidateQueries({ queryKey: ['email_campaigns'] })
    },
  })
}
